export default __webpack_public_path__ + "static/media/construction-worker.81bdeb9e.svg";